import { AppNavigation } from "../components/AppNavigation";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { 
  PenSquare, 
  Image, 
  FileText, 
  Hash,
  Wand2,
  ArrowRight,
  Plus
} from "lucide-react";
import { Link } from "react-router-dom";

export const EditorPage = ({ user, logout, token }) => {
  const tools = [
    {
      icon: <PenSquare className="w-8 h-8" />,
      title: "Crear Post",
      description: "Crea y programa publicaciones para tus redes sociales",
      path: "/composer",
      color: "from-cyan-500/20 to-blue-500/20",
      cta: "Crear nuevo"
    },
    {
      icon: <Image className="w-8 h-8" />,
      title: "Galería",
      description: "Gestiona tu biblioteca de imágenes y videos",
      path: "/media",
      color: "from-purple-500/20 to-pink-500/20",
      cta: "Ver galería"
    },
    {
      icon: <FileText className="w-8 h-8" />,
      title: "Plantillas",
      description: "Usa plantillas prediseñadas para ahorrar tiempo",
      path: "/templates",
      color: "from-orange-500/20 to-yellow-500/20",
      cta: "Ver plantillas"
    },
    {
      icon: <Hash className="w-8 h-8" />,
      title: "Hashtags IA",
      description: "Genera hashtags optimizados con inteligencia artificial",
      path: "/composer?tool=hashtags",
      color: "from-green-500/20 to-emerald-500/20",
      cta: "Generar"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <AppNavigation user={user} logout={logout} />
      
      <main className="lg:ml-64 pt-14 lg:pt-0 pb-20 lg:pb-0">
        <div className="p-6 max-w-6xl mx-auto">
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 rounded-lg bg-gradient-to-br from-primary/20 to-accent/20">
                  <PenSquare className="w-6 h-6 text-primary" />
                </div>
                <h1 className="text-3xl font-bold">Editor</h1>
              </div>
              <p className="text-muted-foreground">
                Crea, edita y gestiona tu contenido para redes sociales
              </p>
            </div>
            <Button asChild size="lg" className="gap-2">
              <Link to="/composer">
                <Plus className="w-5 h-5" />
                Nuevo Post
              </Link>
            </Button>
          </div>

          {/* Tools Grid */}
          <div className="grid md:grid-cols-2 gap-6">
            {tools.map((tool) => (
              <Card 
                key={tool.title}
                className="relative overflow-hidden transition-all hover:shadow-lg group"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${tool.color} opacity-50`} />
                <CardHeader className="relative">
                  <div className="flex items-start justify-between">
                    <div className="mb-4 text-primary">
                      {tool.icon}
                    </div>
                    <Button asChild size="sm" variant="ghost" className="opacity-0 group-hover:opacity-100 transition-opacity">
                      <Link to={tool.path}>
                        <ArrowRight className="w-4 h-4" />
                      </Link>
                    </Button>
                  </div>
                  <CardTitle>{tool.title}</CardTitle>
                  <CardDescription>{tool.description}</CardDescription>
                </CardHeader>
                <CardContent className="relative">
                  <Button asChild variant="secondary" className="w-full">
                    <Link to={tool.path}>
                      {tool.cta}
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* AI Assistant Tip */}
          <Card className="mt-8 border-primary/20">
            <CardContent className="flex items-start gap-4 p-6">
              <div className="p-3 rounded-full bg-primary/10">
                <Wand2 className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold mb-1">Asistente IA integrado</h3>
                <p className="text-muted-foreground text-sm">
                  Todas las herramientas de edición incluyen asistencia de IA. 
                  Genera títulos, captions y hashtags optimizados automáticamente.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default EditorPage;
